import { Modal, Button, Row, Col } from "react-bootstrap";
import {
  getDoctorNextAvailability,
  RequestForRescheduleAppointment,
} from "../../../services/AppointmentsAPI";
import { useEffect, useRef, useState } from "react";
import FloatingLabelDatepicker from "../../../common/DatePicker";
import TimePicker from "../../../common/TimePicker";
import moment from "moment";
import {
  PICKLIST_GROUP_NAME,
  QME_APPOINTMENT_STATUS,
  WEB_ROLE,
} from "../../../common/Constant";
import MultilineTextBox from "../../../common/MultilineTextBox";
import { formatDateTime } from "../../../utils/dateUtils";
import {
  getQMEScheduleDetails,
  updateQMEScheduleDetails,
} from "../../../services/ScheduleAppointmentApi";
import { AppointmentBulkUpdateStatus } from "../../../services/AppointmentListApi";
import Snackbar from "../../../common/Snackbar";
import TextInput from "../../../common/PicklistTesxBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { fetchPickListByGroupName } from "../../../services/CaseInformationApi";
import { fetchSubjectInfo } from "../../../services/Case_SubjectAPI";

interface AppointmentActionProps {
  selectedRows: any[];
  title: any;
  value: any;
  show: boolean;
  onHide: () => void;
  onSaveSuccess?: () => void;
  userRole: any;
}

const AppointmentActionCommonPopUp = ({
  selectedRows,
  title,
  value,
  show,
  onHide,
  onSaveSuccess,
  userRole,
}: AppointmentActionProps) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  const currentTime = moment(new Date()).format("HH:mm");

  const datePickerRef = useRef<HTMLDivElement>(null);
  const [dateOfAppointment, setDateOfAppointment] = useState<Date | null>(
    new Date(),
  );
  const [mediacreLocation, setMedicareLocation] = useState("");
  const [startTime, setStartTime] = useState<any>(currentTime);
  const [reasonForAction, setReasonForAction] = useState<string>("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const [caseStatusOption, setCaseStatusOption] = useState<
    { value: string; label: string }[]
  >([]);

  // multiple rows

  const getDoctorAvailibility = async () => {
    try {
      if (selectedRows.length === 0) return;

      // Step 1: Collect all subjectqmescheduleid values
      const scheduleIds = selectedRows
        .map((row) => row.subjectqmescheduleid)
        .filter((id) => id !== null && id !== undefined);

      if (scheduleIds.length === 0) return;

      // Step 2: Join into comma-separated string
      const scheduleIdString = scheduleIds.join(",");

      // Step 3: Call the API with the string
      const checkAvailabilityData =
        await getDoctorNextAvailability(scheduleIdString);

      // Step 4: Use the first available start date from the result
      if (checkAvailabilityData && checkAvailabilityData.length > 0) {
        const nextAvailableStartDate =
          checkAvailabilityData[0]?.nextAvailableStartDate;

        if (nextAvailableStartDate) {
          const parsedDate = new Date(nextAvailableStartDate);
          setDateOfAppointment(parsedDate);
        }
        const nextAvailableStartTime =
          checkAvailabilityData[0]?.nextAvailableStartTime;

        if (nextAvailableStartTime) {
          const formattedTime = nextAvailableStartTime
            .split(":")
            .slice(0, 2)
            .join(":");
          setStartTime(formattedTime);

          setStartTime(formattedTime);
        }
        setMedicareLocation(checkAvailabilityData[0]?.providerAddress);
      }
    } catch (error) {
      console.error("Error fetching doctor availability:", error);
    }
  };

  useEffect(() => {
    if (
      value == QME_APPOINTMENT_STATUS.RESCHEDULED ||
      value == QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE
    )
      getDoctorAvailibility();
  }, [value]);

  const handleStartTimeChange = (time: string) => {
    setStartTime(time);
  };

  const params = {
    appointment_status: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Status,
      triggerById: loggedInUserid,
    },
  };

  const fetchAppointmentStatus = async () => {
    try {
      const stagePicklistData = await fetchPickListByGroupName(
        params.appointment_status,
      );
      setCaseStatusOption(stagePicklistData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAppointmentStatus();
  }, [loggedInUserid]);

  const reScheduledOption = caseStatusOption.find(
    (item) => item.label === QME_APPOINTMENT_STATUS.RESCHEDULED,
  );

  const reScheduledValue = reScheduledOption?.value;
  const reScheduledLabel = reScheduledOption?.label;

  console.log(value, "value", userRole, "userRole");

  const onSave = async () => {
    if (isSaving) return;
    try {
      setIsSaving(true);
      if (
        value == QME_APPOINTMENT_STATUS.RESCHEDULED &&
        (userRole == WEB_ROLE.Case_Manager ||
          userRole == WEB_ROLE.Practice_Manager)
      ) {
        if (selectedRows.length === 0) return;

        if (!dateOfAppointment || !startTime) {
          const errorMessages = {
            dateOfAppointment: "Please select a date for rescheduling.",
            startTime: "Please select a time for rescheduling.",
          };

          const missingField = !dateOfAppointment
            ? "dateOfAppointment"
            : "startTime";
          setSnackbarMessage(errorMessages[missingField]);
          setError("error");
          setSnackbarOpen(true);
          return;
        }

        // Process each selected row
        for (const row of selectedRows) {
          const scheduleId = row.subjectqmescheduleid;
          const caseInfoId = row.caseInfoId;

          // 1️⃣ Fetch caseSubjectId
          const subjectInfoRes = await fetchSubjectInfo(caseInfoId);
          const caseSubjectId = subjectInfoRes?.caseSubjectId ?? null;

          // 2️⃣ Fetch qmeDoctorContactId
          const scheduleDetailsRes = await getQMEScheduleDetails(scheduleId);
          const qmeDoctorContactId =
            scheduleDetailsRes?.qmeDoctorContactId ?? null;

          const payload = {
            caseSubjectId: caseSubjectId,
            subjectQMEScheduleId: scheduleId,

            dateOfAppointment: dateOfAppointment
              ? formatDateTime(dateOfAppointment)
              : null,

            startTime:
              startTime && dateOfAppointment
                ? formatDateTime(dateOfAppointment, startTime)
                : null,

            endTime:
              startTime && dateOfAppointment
                ? formatDateTime(
                    dateOfAppointment,
                    (() => {
                      const [h, m] = startTime.split(":").map(Number);
                      const end = new Date(dateOfAppointment);
                      end.setHours(h);
                      end.setMinutes(m + 1);
                      return end.toTimeString().slice(0, 5);
                    })(),
                  )
                : null,

            appointmentTypeId: null,
            appointmentCategoryId: null,
            qmeDoctorContactId: qmeDoctorContactId,

            medicalAssistantId: row.medicalAssistantId ?? null,

            appointmentStatusId: reScheduledValue,
            appointmentStatusLable: reScheduledLabel,

            appointmentConfirmationNo: null,
            reasonForVisit: null,
            medicalExamTypeId: null,
            anyAdditionalNeeds: null,

            isInterpreterRequired: null,
            interpreterLanguageId: null,
            interpreterVendorId: null,
            interpreterName: null,
            interpreterPhoneNumber: null,
            interpreterCertificateNumber: null,

            caseSubjectInjuryId: null,
            contactMedicareListId: null,

            medicareId: null,

            providerName: null,
            providerAddress: null,
            physicalCity: null,
            physicalState: null,
            physicalZip: null,

            emailAddress: null,
            phoneNumber: null,
            faxNumber: null,
          };

          console.log("DDDD");

          const response = await updateQMEScheduleDetails(payload);

          if (response?.isSuccess) {
            setError("success");
            setSnackbarMessage("Appointment Updated Successfully.");
            setSnackbarOpen(true);

            setTimeout(() => {
              onHide?.(); // close modal
              onSaveSuccess?.(); // reset filters only on save
            }, 1000);
          }
        }
      }
      if (
        value == QME_APPOINTMENT_STATUS.RESCHEDULED &&
        (userRole == WEB_ROLE.QME_Doctor ||
          userRole == WEB_ROLE.Medical_Assistant ||
          userRole == WEB_ROLE.IndependentQMEDoctor)
      ) {
        if (selectedRows.length === 0) return;

        if (!dateOfAppointment || !startTime) {
          const errorMessages = {
            dateOfAppointment: "Please select a date for rescheduling.",
            startTime: "Please select a time for rescheduling.",
          };

          const missingField = !dateOfAppointment
            ? "dateOfAppointment"
            : "startTime";
          setSnackbarMessage(errorMessages[missingField]);
          setError("error");
          setSnackbarOpen(true);
          return;
        }
        // Step 1: Collect valid subjectqmescheduleid values
        const scheduleIds = selectedRows
          .map((row) => row.subjectqmescheduleid)
          .filter((id) => id !== null && id !== undefined);

        if (scheduleIds.length === 0) return;

        // Step 2: Convert to comma-separated string
        const scheduleIdString = scheduleIds.join(",");

        const formatedActionDate = dateOfAppointment
          ? formatDateTime(dateOfAppointment)
          : null;
        const dateOnly = formatedActionDate?.split("T")[0];

        const requestpayload = {
          subjectQmeScheduleIds: scheduleIdString, // e.g., "241,234"
          startDate: dateOfAppointment ? dateOnly : null,
          startTime:
            startTime && dateOfAppointment
              ? formatDateTime(dateOfAppointment, startTime)
              : null,

          providerAddress: null,
          note: reasonForAction,
        };

        let response = await RequestForRescheduleAppointment(requestpayload);

        if (response?.data?.subjectQmeScheduleId) {
          setError("success");
          setSnackbarOpen(true);
          setSnackbarMessage("Appointment Updated Successfully.");

          setTimeout(() => {
            onHide?.(); // close modal
            onSaveSuccess?.(); // reset filters only on save
          }, 1000);
        }
      }
      if (
        value == QME_APPOINTMENT_STATUS.QME_NO_SHOW ||
        value == QME_APPOINTMENT_STATUS.CANCELLED ||
        value == QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW ||
        value == QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN ||
        value == QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW ||
        value == QME_APPOINTMENT_STATUS.COMPLETED
      ) {
        if (selectedRows.length === 0) return;

        const scheduleIds = selectedRows
          .map((row) => row.subjectqmescheduleid)
          .filter((id) => id !== null && id !== undefined);

        if (scheduleIds.length === 0) return;

        // Step 2: Convert to comma-separated string
        const scheduleIdString = scheduleIds.join(",");

        const statusText =
          value === QME_APPOINTMENT_STATUS.CANCELLED &&
          (userRole === WEB_ROLE.QME_Doctor ||
            userRole === WEB_ROLE.Medical_Assistant)
            ? QME_APPOINTMENT_STATUS.QME_REQUESTED_CANCELLATION
            : value;

        const actionPayload = {
          qmeScheduleIds: scheduleIdString,
          statusText: statusText,
          notes: reasonForAction,
        };

        let response = await AppointmentBulkUpdateStatus(actionPayload);

        if (response?.isSuccess) {
          setError("success");
          setSnackbarOpen(true);
          setSnackbarMessage("Appointment Updated Successfully.");
          setTimeout(() => {
            onHide?.(); // close modal
            onSaveSuccess?.(); // reset filters only on save
          }, 1000);
        } else {
          setSnackbarMessage(
            response?.message || "Failed to update appointment action.",
          );
          setError("error");
          setSnackbarOpen(true);
        }
      }
    } catch (error: any) {
      setError("error");
      setSnackbarOpen(true);
      setSnackbarMessage("An error occurred while processing the appointment.");
      console.error("Error fetching doctor availability:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const statusMessages: Record<string, string> = {
    [QME_APPOINTMENT_STATUS.RESCHEDULED]:
      "Please specify the reason for Reschedule",
    [QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE]:
      "Please specify the reason for Reschedule",
    [QME_APPOINTMENT_STATUS.CANCELLED]:
      "Please specify the reason for cancellation",
    [QME_APPOINTMENT_STATUS.QME_NO_SHOW]:
      "Please specify the reason for QME Doctor No Show",
    [QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN]:
      "Please specify the reason for Patient Check In",
    [QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW]:
      "Please specify the reason for Patient No Show",
    [QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW]:
      "Please specify the reason for Interpreter No Show",
    [QME_APPOINTMENT_STATUS.COMPLETED]: "Please specify the reason",
  };

  <Row className="mt-3">
    {statusMessages[value] && <p>{statusMessages[value]}</p>}
  </Row>;

  return (
    <>
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="recordList"
      >
        <Modal.Header closeButton className="d-flex">
          <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
            Appointment Action - {title}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="fw-bold text-left modelheading ">
          {selectedRows.length > 1 && (
            <>
              {(value === QME_APPOINTMENT_STATUS.RESCHEDULED ||
                value === QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE) && (
                <p className="appointment-count-info fs-13">
                  {selectedRows.length} Appointment(s) during this time will be
                  Rescheduled.
                </p>
              )}

              {value === QME_APPOINTMENT_STATUS.COMPLETED && (
                <p className="appointment-count-info fs-13 text-success">
                  {selectedRows.length} Appointment(s) during this time will be
                  completed.
                </p>
              )}

              {value === QME_APPOINTMENT_STATUS.CANCELLED && (
                <p className="appointment-count-info fs-13 text-danger">
                  {selectedRows.length} Appointment(s) scheduled will be
                  cancelled.
                </p>
              )}
            </>
          )}

          <Row></Row>
          {(value == QME_APPOINTMENT_STATUS.RESCHEDULED ||
            value == QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE) && (
            <Row>
              {mediacreLocation && (
                <>
                  <div className="text-muted mt-2 fs-13">Location</div>
                  <Row className="mt-1 mb-3">
                    <Col sm={12}>
                      <TextInput
                        label="Location"
                        name="location"
                        value={mediacreLocation}
                        disabled
                      />
                    </Col>
                  </Row>
                </>
              )}
              <Col sm={12}>
                <div className="text-muted mt-2 fs-13">Date & Time</div>
              </Col>

              <Col sm={5}>
                <FloatingLabelDatepicker
                  ref={datePickerRef}
                  label="Date"
                  name="dateOfAppointment"
                  value={dateOfAppointment}
                  onChange={(date: Date | null) => {
                    setDateOfAppointment(date);
                    setStartTime("");
                  }}
                  required
                  dateFormat="MM/dd/yyyy"
                  minDate={new Date()}
                />
              </Col>

              <Col sm={5}>
                <TimePicker
                  selectedTime={startTime}
                  onChange={handleStartTimeChange}
                  label="Time"
                  required
                  date={dateOfAppointment}
                />
              </Col>
            </Row>
          )}
          <div className="text-muted mt-3 fs-13">
            {statusMessages[value] && <span>{statusMessages[value]}</span>}
          </div>
          <Row className="mt-1">
            <Col sm={12} className="notemultiline">
              <MultilineTextBox
                label="Reason"
                name="reason"
                value={reasonForAction ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.startsWith(" ")) return;
                  value = value?.trimStart();
                  value = value.replace(/ {2,}/g, " ");
                  setReasonForAction(value);
                }}
                maxLength={100}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={onHide}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={onSave}
            disabled={isSaving}
          >
            <span className="material-icons mx-1">save</span> Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AppointmentActionCommonPopUp;
